export default __webpack_public_path__ + "static/media/1547.6bfa76cf.png";